import { useQuery } from '@apollo/client';
import { useUser } from '../../hooks/useUser';
import { GET_AVAILABLE_GIFT_CODES_QUERY } from './availableGiftCodes.rest';

export const useAvailableGiftCodes = () => {
  const { user } = useUser();
  return useQuery(GET_AVAILABLE_GIFT_CODES_QUERY, { skip: !user.isLoggedIn });
};
